import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './App.css';
import Table from './Table';

function App() {

  const fetchResultsCSVData = () => {
    const csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQHaeepRgmp9xi4pvuFOp62TFyC1HfN8hDBdLNI5xav8EBoPGHu76b02M34X-KJ8mOGP8I_ouGA--2i/pub?gid=516790562&single=true&output=csv'
  
    
    axios.get(csvUrl)    // Use Axios to fetch the CSV data
        .then((response) => {
            const parsedCsvData = parseCSV(response.data);        // Parse the CSV data into an array of objects
            setCsvData(parsedCsvData);        // Set the fetched data in the component's state
            console.log(parsedCsvData);        // Now you can work with 'csvData' in your component's state.
        })
        .catch((error) => {
            console.error('Error fetching CSV data:', error);
        });
  }
  
  function parseCSV(csvText) {
    const rows = csvText.split(/\r?\n/);        // Use a regular expression to split the CSV text into rows while handling '\r'
    const headers = rows[0].split(',');        // Extract headers (assumes the first row is the header row)
    const data = [];        // Initialize an array to store the parsed data
    for (let i = 1; i < rows.length; i++) {
        const rowData = rows[i].split(',');          // Use the regular expression to split the row while handling '\r'
        const rowObject = {};
        for (let j = 0; j < headers.length; j++) {
            rowObject[headers[j]] = rowData[j];
        }
        data.push(rowObject);
    }
    return data;
  }

  useEffect(() => {
    fetchResultsCSVData();    // Fetch the CSV data when the component mounts
    document.title = 'Winter warriors 2025';    // Set the document title
    document.metaThemeColor = 'linear-gradient(to right,rgb(79,138,87), rgb(179,41,38))';    // Set the theme color for the browser
  }, []); // The empty array ensures that this effect runs only once, like componentDidMount

  const [csvData, setCsvData] = useState([]);
  const [tab, setTab] = useState(window.location.href.indexOf('table') > -1 ? 'table' : 'results');  

  return (
    <div className="App">
      <nav className="App-nav">
        <ul>
          <li><a href="#results" className={tab === 'results' ? 'active' : ''} onClick={() => setTab('results')}>Results</a></li>
          <li><a href="#table"  className={tab === 'table' ? 'active' : ''} onClick={() => setTab('table')}>Table</a></li>
        </ul>
      </nav>
      <main className="App-main">
        {tab === 'results' && (
        <div className="scores-container">
          {csvData.map((row, index) => (
            <div key={index} className="score-row">
              <div className="time">{row['Time']}</div>
              <div className="teams">
                <div className="team-container">
                  {row['Team 1 Logo'] && <img className="team-logo" src={"/futsal/teams/" + row['Team 1 Logo'] + ".png"} alt={row['Team 1']} />}
                  <span className="team">{row['Team 1']}</span>
                </div>
                <div className="score-separator">
                  <span className="score">{row['Score Team 1']}</span>
                  <span className="colon">:</span>
                  <span className="score">{row['Score Team 2']}</span>
                </div>
                <div className="team-container">
                  {row['Team 2 Logo'] && <img className="team-logo" src={"/futsal/teams/" + row['Team 2 Logo'] + ".png"} alt={row['Team 2']} />}
                  <span className="team">{row['Team 2']}</span>
                </div>
              </div>
            </div>
          ))}
        </div>)}


        {tab === 'table' && <Table csvData={csvData} />}


      </main>
      <footer className="App-footer">
        <p>&copy; 2025 Futsal Scores</p>
      </footer>
    </div>
  );
}

export default App;
